<div class="summary-total-occupancy">
    <span class="summary-highlight-text">{{searchParams?.arrival | date}}</span> - <span class="summary-highlight-text">{{searchParams?.departure | date}}</span>,
    <span class="summary-highlight-text">{{totalOccupancy.rooms}} </span> @if (totalOccupancy.rooms > 1) {{{"pr.rooms"|translate}}}@else{{{"pr.room"|translate}}},
    <span class="summary-highlight-text">{{totalOccupancy.adults}} </span> @if (totalOccupancy.adults > 1) {{{"pr.adults"|translate}}}@else{{{"pr.adult"|translate}}}@if(totalOccupancy.children > 0){,
    <span class="summary-highlight-text">{{totalOccupancy.children}} </span> @if (totalOccupancy.children == 1) {{{"pr.child"|translate}}}@else{{{"pr.children"|translate}}}
    }
</div>

@if (rooms.length > 1) {

    <p-tabs [value]="0" #tab>

        <p-tablist class="profile-summary-tabs">
            @for (cartItem of rooms; track $index) {
                <p-tab [value]="$index" [attr.data-testid]="'room-summary-tab-' + $index">{{"pr.Room"|translate}} {{$index + 1}}
                </p-tab>
            }
        </p-tablist>
        @for (cartItem of rooms; track $index) {


            <p-tabpanel [value]="$index">
                <div class="profile-summary">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            @if (tab.value() == $index) {
                                <app-image-gallery1 [roomCode]="cartItem.item.room.roomCode" [hotelCode]="cartItem.searchParams.hotelCode"></app-image-gallery1>
                            }

                        </div>
                        <div class="col-12 col-md-8">
                            <div class="summary-room-data">
                                <h2 [attr.data-testid]="'summary-room-heading'">{{cartItem.item.room.pim?.name ?? cartItem.item.room.roomName}} </h2>
                                <span class="summary-highlight-text">{{cartItem.getSearchParams().roomData[$index].adults}} </span> @if (cartItem.getSearchParams().roomData[$index].adults > 1) {{{"pr.adults"|translate}}}@else{{{"pr.adult"|translate}}}@if(cartItem.getSearchParams().roomData[$index].children > 0){,
                                <span class="summary-highlight-text">{{cartItem.getSearchParams().roomData[$index].children}} </span> @if (cartItem.getSearchParams().roomData[$index].children == 1) {{{"pr.child"|translate}}}@else{{{"pr.children"|translate}}}, {{'pr.age'|translate}}: {{cartItem.getSearchParams().roomData[$index].childAges.join(',') }}  }
                                <br>

                                <div class="summary-room-short-description" [innerHTML]="cartItem.item.room.pim?.shortDescription"></div>
                                <div class="summary-rate-name">
                                    {{cartItem.item|formatRateName}}
                                </div>
                                <div class="summary-rate-desc" [innerHTML]="cartItem.item.rate.pim?.rateDescription || cartItem.item.rate.rateDescription"></div>

                                <div class="summary-price" [innerHTML]="cartItem.item.totalPriceForStayWithTaxes|displayPrice" [attr.data-testid]="'summary-room-price'">

                                </div>
                                <div class="summary-cancellation-policy" [innerHTML]="cartItem.item.rate.pim?.cancellationPolicy"></div>

                            </div>
                        </div>
                    </div>
                </div>
            </p-tabpanel>
        }
    </p-tabs>
}
@else {


    <!-- FIXAA TOISTO -->

    <div class="profile-summary">
        <div class="row">
            <div class="col-12 col-md-4">
                <app-image-gallery1 [roomCode]="rooms[0].item.room.roomCode" [hotelCode]="rooms[0].searchParams.hotelCode"></app-image-gallery1>
            </div>
            <div class="col-12 col-md-8">
                <div class="summary-room-data">
                    <h2 [attr.data-testid]="'summary-room-heading'">{{rooms[0].item.room.pim?.name ?? rooms[0].item.room.roomName}}</h2>

                    <div class="summary-room-short-description" [innerHTML]="rooms[0].item.room.pim?.shortDescription"></div>
                    <div class="summary-rate-name">
                        {{rooms[0].item|formatRateName}}
                    </div>
                    <div class="summary-rate-desc" [innerHTML]="rooms[0].item.rate.pim?.rateDescription || rooms[0].item.rate.rateDescription"></div>

                    <div class="summary-price" [innerHTML]="rooms[0].item.totalPriceForStayWithTaxes|displayPrice" [attr.data-testid]="'summary-room-price'"></div>
                    <div class="summary-cancellation-policy" [innerHTML]="rooms[0].item.rate.pim?.cancellationPolicy"></div>

                </div>
            </div>
        </div>
    </div>
}



